import { useCallback } from "react";
import { ACN } from "../../core/form/ACN";
import { Text } from "../../core/form/Text";
import { useConditional } from "../../core/hooks/useConditional";
import { DataContext, useDataContext } from "../../core/hooks/useData";
import { useSaveAwareness } from "../../core/hooks/useSaveContext";
import { Modal } from "../../core/ui/Modal";
import { Table } from "../../core/ui/Table";
import { first } from "../../core/utils/array";
import { FormInline, prepareFormDataForSave } from "../../data-entry/FormModal";
import { DateCol, GenericCol } from "../../layout/TableCells";
import { Company, Name, SMSF, Trust } from "../../types";
import { EditTrackedItem } from "./EditTrackedItem";
import { formatData } from "./Format";
import { parseTrackedItems } from "./parseTrackedItem";
import { HistoryModal } from "./HistoryModal";
import { TrackedItemDisplay } from "./TrackedItemDisplay";
import { Addresses } from "./Address";
import { Tab, TabContainer } from "../../core/ui/Tab";
import { CompanyOfficers } from "./CompanyOfficer";
import { CompanyShareholders } from "./CompanyShareholder";
import { TrustTrustees } from "./TrustTrustees";
import { SMSFTrustees } from "./SMSFTrustees";
import { SMSFMembers } from "./SMSFMembers";


export function SMSFEdit(props: {
	smsf: SMSF,
}) {

	const { smsf } = props;

	const names = parseTrackedItems(smsf.names);
	const name = first(names.active);
	if (!smsf.names) smsf.names = [];

	if (!smsf.trustees) smsf.trustees = [];
	if (!smsf.members) smsf.members = [];


	const edit = useConditional(() => {
		return (
			<EditTrackedItem
				title="Edit Trust Name"

				arr={smsf.names}
				initialValues={name}

				canHaveOnlyOneActive={true}

				form="entity-trust-name-edit"
				formOptions={{
					showEffective: true,
				}}

				onCancel={edit.close}
				onClose={edit.close}
			/>
		)
	});

	const history = useConditional(() => {
		return (
			<HistoryModal
				title="Name History"
				onClose={history.close}
				items={smsf.names}
				cols={[
					GenericCol("Name", "name"),
				]}
			/>
		);
	})	
debugger;
	return (
		<TabContainer displayStyle="border-indent">
			<Tab title="Details">
				<div className="flex horiz align-start gap-10 space-evenly">
					<TrackedItemDisplay
						title="Name"
						item={name}
						edit={edit}
						history={history}
						className="bold"
					>
						{
							formatData(
								name ? 
								{
									lines: [ { parts: [ name.name ]} ]
								}
								: undefined
							)
						}
					</TrackedItemDisplay>

					<FormInline
						form="entity-smsf-edit"
						obj={props.smsf}
					/>
				</div>
			</Tab>

			<Tab title="Trustees">
				<SMSFTrustees trustees={props.smsf.trustees} />
			</Tab>
			<Tab title="Members">
				<SMSFMembers items={props.smsf.members} />
			</Tab>

			<Tab title="Relationships">

			</Tab>
			<Tab title="Documents">

			</Tab>
		</TabContainer>
	);
}